<button mat-stroked-button color="accent" (click)="depositWithoutBonus.next()">
	{{ "payment.deposit-without-reward.button-title" | translate }}
</button>
<obg-m-deposit-bonus-item
	*ngFor="let item of items; trackBy: trackByBonus"
	[item]="item"
	(getBonus)="getBonus.next(item)"
>
</obg-m-deposit-bonus-item>
